import * as Ariakit from '@ariakit/react';
import { forwardRef, useContext } from '@wordpress/element';
import { Context } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const TriggerButton = forwardRef(function TriggerButton({
  children,
  disabled = false,
  ...props
}, ref) {
  const menuContext = useContext(Context);
  if (!menuContext?.store) {
    throw new Error('Menu.TriggerButton can only be rendered inside a Menu component');
  }
  if (menuContext.store.parent) {
    throw new Error('Menu.TriggerButton should not be rendered inside a nested Menu component. Use Menu.SubmenuTriggerItem instead.');
  }
  return /*#__PURE__*/_jsx(Ariakit.MenuButton, {
    ref: ref,
    ...props,
    disabled: disabled,
    store: menuContext.store,
    children: children
  });
});